import React from 'react';
import { Link, User } from './types';

interface SlideshowSectionProps {
  user: User;
  slideshow: Link[];
  onOpenSlide: (slide: unknown) => void;
}

const SlideshowSection: React.FC<SlideshowSectionProps> = ({
  user,
  slideshow,
  onOpenSlide: _onOpenSlide,
}) => {
  if (user?.backgroundSettings?.slideshowHidden || !slideshow?.length) {
    return null;
  }

  return (
    <div className="mx-auto mb-10 w-full max-w-[540px]">
      {/* Slideshow component would go here */}
    </div>
  );
};

export default SlideshowSection;
